import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

import {helper, http, route, api} from './common/common';
import FormPaper from './common/FormPaper';

const styles = (theme) => {
    return {
        root: {
            width: 450,
            height: 500,
        },
        controlGroup: {
            position: 'absolute',
            width: '100%',
            right: 0,
            bottom: 0,
            margin: 0,
        },
        control: {
            float: 'right',
            marginRight: 0,
            marginLeft: 16,
        },
        select: {
            marginTop: 40,
            width: '100%',
            textAlign: 'left',
        },
        selectMenu: {
            backgroundColor: theme.palette.background.paper,
            maxHeight: '40%',
        },
        selectDisplay: {
            paddingLeft: 4,
            paddingRight: 32,
            '&$selectDisabled': {
                color: theme.palette.primary.disabledDisplayText,
            },
            '&:focus': {
                backgroundColor: theme.palette.common.transparent,
            }
        },
        selectMenuItem: {
            '&:hover': {
                backgroundColor: theme.palette.primary.hoverOverlay,
            },
            '&$selectSelected': {
                color: theme.palette.primary.selectedDisplayText,
            },
            '&$selectSelected:not(:hover)': {
                backgroundColor: theme.palette.common.transparent,
            }
        },
        selectDisabled: {},
        selectSelected: {},
        inputUnderline: {
            '&:hover:not($inputDisabled):not($inputFocused):not($inputError):before': {
                borderBottomWidth: 1,
                borderBottomStyle: 'solid',
                borderBottomColor: 'rgba(0, 0, 0, 0.42)',
            },
            '&:before': {
                borderBottomWidth: 1,
                borderBottomStyle: 'solid',
                borderBottomColor: 'rgba(0, 0, 0, 0.42)',
            },
            '&:after': {
                borderBottomWidth: 2,
                borderBottomStyle: 'solid',
                borderBottomColor: theme.palette.secondary.main,
            },
        },
        inputError: {},
        inputFocused: {},
        inputDisabled: {},
        progressContainer: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: 200,
            height: 95,
            margin: 'auto',
        },
        progress: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            width: 80,
            height: 80,
            marginLeft: 'auto',
            marginRight: 'auto',
            color: theme.palette.primary.light,
        },
        progressText: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
        },
    };
}

class OrganizationSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            silent: this.props.silent,
            organizationId: 0,
            organization: [],
        };

        this._cancelToken = http.CancelToken.source();

        this._requestList();
    }

    componentWillUnmount = () => {
        if (this._cancelToken) {
            this._cancelToken.cancel();
        }
    }

    render = () => {
        if (this.state.silent || this.state.organization.length === 0) {
            return this._renderProgress();
        }

        const {classes} = this.props;

        const selectClasses = {
            select: classes.selectDisplay,
            disabled: classes.selectDisabled,
        };

        const inputClasses = {
            underline: classes.inputUnderline,
            error: classes.inputError,
            focused: classes.inputFocused,
            disabled: classes.inputDisabled,
        };

        const menuProps = {
            classes: {
                paper: classes.selectMenu,
            },
            MenuListProps: {
            },
            PopoverClasses: {
            },
            getContentAnchorEl: null,
            anchorReference: 'anchorEl',
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
        };

        return (
            <FormPaper
                className={classes.root}
                heading='Select organization'
                subHeading='to start using the Agriculture Service'
            >
                <Select
                    className={classes.select}
                    classes={selectClasses}
                    input={<Input classes={inputClasses}/>}
                    MenuProps={menuProps}
                    value={this.state.organizationId}
                    onChange={this._handleSelection}
                >
                    {this.state.organization}
                </Select>
                <div className={classes.controlGroup}>
                    <Button
                        className={classes.control}
                        id='next'
                        variant='contained'
                        color='secondary'
                        onClick={this._handleNext}
                    >
                        Next
                    </Button>
                </div>
            </FormPaper>
        );
    }

    _renderProgress = () => {
        const {classes} = this.props;

        return (
            <div className={classes.progressContainer}>
                <CircularProgress
                    className={classes.progress}
                    size={60}
                />
                <Typography
                    className={classes.progressText}
                    align='center'
                >
                    Preparing Organization...
                </Typography>
            </div>
        );
    }

    _handleNext = (event) => {
        this._requestOrganizationSelect(this.state.organizationId);
    }

    _handleSelection = (event) => {
        this.setState({organizationId: event.target.value});
    }

    _redirectToContactUs = () => {
        this.props.setAccessCode('');
        route(this, '/contact-us', '');
    }

    _processError = (error) => {
        this.props.setAccessCode('');

        if (this.state.silent) {
            route(this, '/home', '');
            return;
        }

        if (error.response && error.response.status === 401) {
            if (error.response.data.error === 'invalid_client') {
                this.props.setAccessCode('');

                this.props.setError(
                    'Session Expired',
                    'expired',
                    'Your session has either expired or is no longer valid',
                    () => {
                        this.props.setAccessCode('');
                        route(this, '/home', '');
                    });

                return;
            } else if (error.response.data.error === 'invalid_privilege') {
                this.props.setError(
                    'Invalid Privilege',
                    'privilege',
                    'You do not have privilege to access the service',
                    () => {
                        this.props.setAccessCode('');
                    });

                return;
            }
        }

        this.props.setError(
            error.response.data.error_title,
            'generic',
            error.response.data.error_description,
            () => {
                this.props.setAccessCode('');
            });
    }

    _requestList = async () => {
        try {
            const response = await http.get(api.organization() + '/mapping', {
                params: {
                    'access_code': this.props.getAccessCode(),
                },
                cancelToken: this._cancelToken.token,
            });

            if (this.state.silent) {
                this.setState({silent: false});
            }

            if (response.data.organization_data.length === 0) {
                this._redirectToContactUs();
            } else {
                const organization = [];

                if (response.data.organization_data.length === 1) {
                    const orgId = response.data.organization_data[0].organization_id;
                    this._requestOrganizationSelect(orgId);
                    return;
                }

                const {classes} = this.props;

                const menuItemClasses = {
                    root: classes.selectMenuItem,
                    selected: classes.selectSelected,
                }

                for (const v of response.data.organization_data) {
                    organization.push(<MenuItem
                        classes={menuItemClasses}
                        value={v.organization_id}
                        key={v.organization_id}
                    >{v.organization_name}</MenuItem>);
                }

                this.setState({
                    organizationId: response.data.organization_data[0].organization_id,
                    organization: organization,
                });
            }
        } catch (error) {
            if (http.isCancel(error)) {
                return;
            }

            const e = helper.sanitizeError(error, 'Failed', 'Unable to select organization');
            this._processError(e);
        }
    }

    _requestOrganizationSelect = async (orgId) => {
        try {
            const response = await http.post(api.organization() + '/select', {
                'access_code': this.props.getAccessCode(),
                'organization_id': orgId,
            }, {
                cancelToken: this._cancelToken.token,
            });

            this.props.setAccessCode(response.data.access_code);

            route(this, '/main/prelogin', '', this.props.location.state);
        } catch (error) {
            if (http.isCancel(error)) {
                return;
            }

            this._processError(error);
        }
    }
}

OrganizationSelect.propTypes = {
    setError: PropTypes.func.isRequired,
    getAccessCode: PropTypes.func.isRequired,
    setAccessCode: PropTypes.func.isRequired,
}

export default withStyles(styles)(OrganizationSelect);
